module.exports = __webpack_public_path__ + "img/img_03.31f0ea5c.jpg";